module.exports = __webpack_public_path__ + "static/img/LOGO12.ecdff5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/LOGO12.png
// module id = hyxE
// module chunks = 0